import { CoinIcon, DiscountIcon, Profile2UserIcon, StarIcon2 } from 'assets/Icons';
import QUERY_KEYS from 'network/config/queryKeys';
import { getReferralCount, getReferralRewards, ReferralAwards, ReferralList } from 'network/services/referals';
import { useQuery, UseQueryResult } from 'react-query';
import { Link } from 'react-router-dom';

const money = (amount: number) =>
  amount.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const signedUpOn = (value: string) => {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-NG', { day: 'numeric', month: 'short', year: 'numeric' });
};

const RefferalsInfo = () => {
  const awardsQuery: UseQueryResult<ReferralAwards> = useQuery(
    [QUERY_KEYS.REFFERAL_REWARD],
    getReferralRewards,
    { retry: 1 }
  );
  const referralsQuery: UseQueryResult<ReferralList> = useQuery(
    [QUERY_KEYS.REFFERAL_TOTAL],
    getReferralCount,
    { retry: 1 }
  );
  const awards = awardsQuery.data;
  const referrals = referralsQuery.data;

  const totalReward = awards?.totalReward ?? referrals?.totalReward ?? 0;
  const referralCount = awards?.referralCount ?? referrals?.referralCount ?? 0;
  const rewardPerReferral = awards?.rewardPerReferral ?? referrals?.rewardPerReferral ?? 500;
  const discountPercent = awards?.discountPercent ?? referrals?.discountPercent ?? 0;
  const friends = referrals?.friends ?? [];

  return (
    <>
      <div className="p-4 py-6 rounded-md flex md:items-center flex-col md:flex-row w-full justify-between bg-white">
        <div className="flex items-center w-full justify-between">
          <div className="flex gap-3 flex-col">
            <h3>Total Reward Earned</h3>
            <span>&#8358; {money(totalReward)}</span>
            <Link className="text-primary underline" to="/account/wallet">
              View wallet balance
            </Link>
          </div>
          <StarIcon2 />
        </div>
        <div className="h-px w-full md:min-h-[160px] md:w-px my-6 md:my-0 md:mx-6 bg-black/10" />
        <div className="flex flex-col gap-4 w-full">
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center gap-2">
              <CoinIcon />
              <span>Per signup</span>
            </div>
            <span className="font-semibold text-lg">&#8358; {money(rewardPerReferral)}</span>
          </div>
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center gap-2">
              <Profile2UserIcon />
              <span>Referrals</span>
            </div>
            <span className="font-semibold text-lg">{referralCount}</span>
          </div>
          <div className="flex items-center w-full justify-between">
            <div className="flex items-center gap-2">
              <DiscountIcon />
              <span>Discount</span>
            </div>
            <span className="font-semibold text-lg">{discountPercent}%</span>
          </div>
        </div>
      </div>
      <div className="bg-white mt-4 p-4 py-5 rounded-xl">
        <h3 className="font-semibold text-lg">Friends who signed up</h3>
        {friends.length === 0 ? (
          <p className="text-black/50 mt-3">No one has signed up with your code yet.</p>
        ) : (
          <ul className="mt-4 flex flex-col gap-3">
            {friends.map(friend => (
              <li key={friend.id} className="flex items-center justify-between gap-3 border-b border-black/5 pb-3">
                <div>
                  <p className="font-medium">{friend.name}</p>
                  {friend.createdAt ? <p className="text-sm text-black/50">{signedUpOn(friend.createdAt)}</p> : null}
                </div>
                <span className="font-semibold">&#8358; {money(friend.reward)}</span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </>
  );
};

export default RefferalsInfo;
